/**
 * @function debounce
 * @memberof Promega.Util
 * @description Returns a function, that, as long as it continues to be invoked, will not be triggered. The function will be called after it stops being called for N milliseconds. If `immediate` is passed, trigger the function on the leading edge, instead of the trailing.
 * @param {Function} func The input function to modify
 * @param {Number} wait The number of milliseconds to wait before firing the function
 * @param {Boolean} immediate If true, fires the function on the leading edge rather than the trailing edge
 * @returns {Function} A new version of the function that will be debounced when called
 */
export default function debounce (func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}
